export default "__VITE_ASSET__DkvncJtt__"